import mitt from 'mitt'

const emitter = mitt()

export const EmitterEventTypes = {
    CLIENT_TOKEN_UPDATED: 'client-token-updated',
    OPEN_ASSISTANT_WITH_PROMPT: 'open-assistant-with-prompt',
};

export default emitter;
